import { useContext, useEffect, useMemo, useRef } from "react";

import Hero from "../../components/marketing/homepage/Hero";
import Manifesto from "../../components/marketing/homepage/Manifesto";
import Scenes from "../../components/marketing/homepage/Scenes";
import HowItWorks from "../../components/marketing/homepage/HowItWorks";
import Approach from "../../components/marketing/homepage/Approach";
import Founder from "../../components/marketing/homepage/Founder";
import TeamBackgrounds from "../../components/marketing/homepage/TeamBackgrounds";
import Audience from "../../components/marketing/homepage/Audience";
import Footer from "../../components/marketing/homepage/Footer";
import BlogPreview from "../../components/marketing/BlogPreview";
import Seo from "../../components/seo/Seo";
import { blogPosts } from "../../content/blogPosts";
import { siteMetadata } from "../../content/siteMetadata";
import { ApplicationContext } from "../../context/GlobalState";
import { setActiveSection, setPageMetadata } from "../../context/actions";
import MarketingLayout from "../../layouts/MarketingLayout";
import { sortBlogPosts } from "../../utils/siteUtils";

const Home = () => {
  const heroRef = useRef(null);
  const [state, dispatch] = useContext(ApplicationContext);

  const latestPosts = useMemo(() => sortBlogPosts(blogPosts).slice(0, 3), []);

  useEffect(() => {
    dispatch(
      setPageMetadata({
        title: "Kanzi — The Enterprise Brain for Healthcare | Data Chimp Labs",
        description:
          "A private AI with persistent memory that lives inside your organization. Live in weeks. Data never leaves your walls.",
        image: siteMetadata.socialImage,
        pathname: "/",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const sectionIds = ["scenes", "how-it-works", "about", "audience", "blog"];
    const observedElements = sectionIds
      .map((sectionId) => document.getElementById(sectionId))
      .filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntry = entries.find((entry) => entry.isIntersecting);
        if (visibleEntry?.target?.id) {
          dispatch(setActiveSection(visibleEntry.target.id));
        }
      },
      { threshold: 0.3, rootMargin: "-20% 0px -55% 0px" }
    );

    observedElements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [dispatch]);

  return (
    <>
      <Seo
        title="Kanzi — The Enterprise Brain for Healthcare | Data Chimp Labs"
        description="A private AI with persistent memory that lives inside your organization. Live in weeks. Data never leaves your walls."
        pathname="/"
        image={siteMetadata.socialImage}
      />

      <MarketingLayout heroRef={heroRef} footer={<Footer />}>
        <Hero heroRef={heroRef} prefersReducedMotion={state.prefersReducedMotion} />
        <div className="glow-line" />
        <Manifesto />
        <div className="glow-line" />
        <Scenes />
        <div className="glow-line" />
        <HowItWorks />
        <div className="glow-line" />
        <Approach />
        <div className="glow-line" />
        {/* <Founder /> */}
        <TeamBackgrounds />
        <div className="glow-line" />
        <Audience />
        <div className="glow-line" />
        <BlogPreview posts={latestPosts} />
      </MarketingLayout>
    </>
  );
};

export default Home;
